class PromotionTracker extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.hasTracked) {
          this.trackPromotion();
          this.hasTracked = true;
          this.observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    this.observer.observe(this);

    this.querySelectorAll('.button').forEach((button) => {
      button.addEventListener('click', () => this.selectPromotion());
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  trackPromotion() {
    Shopify.analytics.publish('karl:view_promotion', {
      promotion_name: this.dataset.promotionName,
      promotion_id: this.dataset.promotionId,
      is_promotion: this.dataset.isPromotion,
    });
  }

  selectPromotion() {
    Shopify.analytics.publish('karl:select_promotion', {
      promotion_name: this.dataset.promotionName,
      promotion_id: this.dataset.promotionId,
      is_promotion: this.dataset.isPromotion,
    });
  }
}

customElements.define('promotion-tracker', PromotionTracker);
